import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

//auth
import useAuth from '../context/hook/useAuth'

//component
import { Header } from './header/header'
import { Footer } from '../Home/Footer'
import { Withdrawal } from './history/Withdrawal';
import { Deposit } from './history/Deposit';
import { Token } from './history/Token';
import { MiniHeader } from '../Home/MiniHeader';
import webSocket from '../utils/webSocket'
import useWebSocket from 'react-use-websocket';
import site from "../utils/SiteSettings"

import QRCode from "react-qr-code";


//toast
import 'react-toastify/dist/ReactToastify.css'; // import first and after the toastify is work 
import { toast } from 'sonner'

export const Wallet = () => {

    const {user} = useAuth()

    const [balance, setBalance] = useState([])

    const [showIcon, setShowIcon] = useState(false)

    const [showWith, setshowWith] = useState(false)

    const [showDepo, setshowDepo] = useState(true)

    const [showToken, setshowToken] = useState(false)

    const [isLoading, setIsLoading] = useState(true)

    const [copyStatus, setCopyStatus] = useState(false);
        
    const Address = site?.site?.tokenAdd

  const { lastJsonMessage } = new useWebSocket(`${webSocket}/user/balance`,{protocols: user})

  useEffect(()=>{
    //checking a last message is coming or not 
    if (lastJsonMessage !== null) {
    //   console.log(lastJsonMessage)
        setBalance(lastJsonMessage)
    }
  },[lastJsonMessage])

    const handlSshowHide =()=>{
        setShowIcon(!showIcon)
    }

    const showWithdrawal = () =>{
        if(showWith === true){
            return
        }else{
            setshowWith(!showWith)
            setshowToken(false)
            setshowDepo(false) 
        }
    }

    const showDeposit = () =>{
        if(showDepo === true){
            return
        }else{
            setshowWith(false)
            setshowToken(false)
            setshowDepo(!showDepo) 
        }
    }

    const showCoinstirs = () =>{
        if(showToken === true){
            return
        }else{
            setshowWith(false)
            setshowToken(!showToken)
            setshowDepo(false)
        }
    }

    setTimeout(()=>{
        setIsLoading(false)
    },2000)

    const handleCopy = ()=>{
        try {
            // console.log(Address)
            navigator.clipboard.writeText(Address && Address.toString())
            setCopyStatus(true);
            toast.success("Coped ",{position:'top-right'})
            setTimeout(() => setCopyStatus(false), 2000)
        } catch (error) {
            toast.error("Some thing went wrong. please try to copy directly",{position:"top-right"})
            console.log(error)
        }
    }
    return (
        <>
        {
            isLoading ? (
                <>
                    <div style={{position:"relative",justifyItems:"center",marginTop:"20%"}}>
                         <div id="preloader">
                            <div id="loader">
                                <img src={require("../../assets/logo.png")} alt="loader" />
                            </div>
                        </div>
                    </div>
                </>
            ):(
                <>
                    <div className="inner-bg" >
                        <Header />
                        {/* <!-- service section start --> */}
                        <section className="feature-section pb-0">
                            <div className="container pb-md-5 pb-0">
                                <div className="title-basic fs-sm">
                                
                                </div>
                                <ul className="tab-section mt-80">
                                    <li className="active"><Link to={""}>Wallet</Link></li>
                                    <li><Link to={"/buy/token"}>Buy {site?.site?.siteName}</Link></li>
                                    <li><Link to={"/deposit"}>Deposit</Link></li>
                                    <li><Link to={"/withdrawal"}>Withdraw</Link></li>
                                    <li><Link to={"/setting"}>Settings</Link></li>
                                    <li><MiniHeader /></li>
                                </ul>
                                <div className="row g-xxl-5 g-4">
                                    <div className="col-lg-12">
                                        <div className="dfafa451">
                                            <div className="_8979253c">
                                            <span className="_6e618a34">Estimated Balance</span>
                                            <span className="f6d83fd9" onClick={handlSshowHide}>
                                                <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9 12.1427C12.321 12.1427 15.2833 10.0959 16.6166 6.99986C15.2833 3.90386 12.321 1.857 9 1.857C5.679 1.857 2.71671 3.90386 1.38343 6.99986C2.71671 10.0959 5.679 12.1427 9 12.1427ZM9 0.571289C13.1079 0.571289 16.6153 3.24043 18 6.99986C16.6153 10.7593 13.1079 13.4284 9 13.4284C4.89214 13.4284 1.38471 10.7593 0 6.99986C1.38471 3.24043 4.89214 0.571289 9 0.571289ZM9 9.57129C8.31802 9.57129 7.66396 9.30037 7.18173 8.81813C6.69949 8.3359 6.42857 7.68185 6.42857 6.99986C6.42857 6.31787 6.69949 5.66382 7.18173 5.18159C7.66396 4.69935 8.31802 4.42843 9 4.42843C9.68198 4.42843 10.336 4.69935 10.8183 5.18159C11.3005 5.66382 11.5714 6.31787 11.5714 6.99986C11.5714 7.68185 11.3005 8.3359 10.8183 8.81813C10.336 9.30037 9.68198 9.57129 9 9.57129ZM9 10.857C9.50653 10.857 10.0081 10.7572 10.4761 10.5634C10.944 10.3696 11.3692 10.0854 11.7274 9.72727C12.0856 9.3691 12.3697 8.94389 12.5635 8.47592C12.7574 8.00795 12.8571 7.50639 12.8571 6.99986C12.8571 6.49333 12.7574 5.99177 12.5635 5.5238C12.3697 5.05583 12.0856 4.63062 11.7274 4.27245C11.3692 3.91428 10.944 3.63016 10.4761 3.43632C10.0081 3.24249 9.50653 3.14272 9 3.14272C7.97702 3.14272 6.99594 3.54909 6.27259 4.27245C5.54923 4.9958 5.14286 5.97688 5.14286 6.99986C5.14286 8.02284 5.54923 9.00392 6.27259 9.72727C6.99594 10.4506 7.97702 10.857 9 10.857Z" fill="#616161"></path>
                                                </svg>
                                            </span>
                                            </div>
                                            <div className="_802fc171">
                                                {   showIcon ? 
                                                        <div className="fed61cf8">{balance === '' ? 0 : ((balance.bnb*balance.price)+balance.usdt+((balance.price2*balance.token)/balance.price1)).toFixed(6)} USDT </div>
                                                            : 
                                                        <div className="fed61cf8" >XXXX</div>
                                                }
                                                <div className="_731ec4d9"></div>
                                                <div className="_08daca67"></div>
                                            </div>
                                            <div className="_3b04c316">
                                                <div className="_8b305fc7">
                                                    <div className="_66590ade">
                                                        <div className="_92aab3aa">BNB</div>
                                                        <div className="_3fdd424e">
                                                            <div className="a3e2e302"> {balance && balance?.bnb?.toFixed(6)} BNB </div>
                                                        </div>
                                                        <div className="_53ae92b4"> 
                                                            Available: <span className=""> {balance && balance?.bnb1?.toFixed(6)} BNB </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="_8b305fc7">
                                                    <div className="_66590ade">
                                                        <div className="_92aab3aa">USDT </div>
                                                        <div className="_3fdd424e">
                                                            <div className="a3e2e302"> {balance && balance?.usdt?.toFixed(6)} USDT </div>
                                                        </div>
                                                        <div className="_53ae92b4">
                                                            Available: <span className=""> {balance && balance?.usdt1?.toFixed(6)} USDT </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="_8b305fc7">
                                                    <div className="_66590ade">
                                                        <div className="_92aab3aa">{site?.site?.siteName} </div>
                                                        <div className="_3fdd424e">
                                                            <div className="a3e2e302"> {balance && balance?.token?.toFixed(6)} {site?.site?.siteName} </div>
                                                        </div>
                                                        <div className="_53ae92b4">
                                                            Available: <span className=""> {balance && balance?.token1?.toFixed(6)} {site?.site?.siteName} </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* <div className="_8b305fc7">
                                                    <div className="_66590ade">
                                                        <div className="_92aab3aa">ETH </div>
                                                        <div className="_3fdd424e">
                                                            <div className="a3e2e302"> {balance && balance?.eth?.toFixed(6)} ETH </div>
                                                        </div>
                                                        <div className="_53ae92b4">
                                                            Available: <span className=""> {balance && balance?.eth1?.toFixed(6)} ETH </span>
                                                        </div>
                                                    </div>
                                                </div> */}
                                                <div className="_8b305fc7">
                                                    <div className="_66590ade">
                                                        <div className="_92aab3aa">TRX </div>
                                                        <div className="_3fdd424e">
                                                            <div className="a3e2e302"> {balance && balance?.trx?.toFixed(6)} TRX </div>
                                                        </div>
                                                        <div className="_53ae92b4">
                                                            Available: <span className=""> {balance && balance?.trx1?.toFixed(6)} TRX </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <!----> */}
                                        </div>
                                        <div className="tran-history">
                                            <h3>History</h3>
                                            <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                                                <li className="nav-item" role="presentation">
                                                <button onClick={showDeposit} className={`nav-link ${showDepo ? "" : "active" }`} id="pills-home-tab" data-bs-toggle="collapse" data-bs-target="#deposit" type="button" role="tab" aria-controls="pills-home" aria-selected="true">Deposit</button>
                                                {/* <button class="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">Deposit</button> */}
                                                </li>
                                                <li className="nav-item" role="presentation">
                                                <button onClick={showWithdrawal} className={`nav-link ${showWith ? "" : "active" }`} id="pills-profile-tab" data-bs-toggle="collapse" data-bs-target="#withdrawal" type="button" role="tab" aria-controls="pills-profile" aria-selected="false" tabIndex="-1">Withdraw</button>
                                                {/* <button class="nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false" tabindex="-1">Withdraw</button> */}
                                                </li>
                                                <li className="nav-item" role="presentation">
                                                    <button onClick={showCoinstirs} className={`nav-link ${showToken ? "" : "active" }`} id="pills-profile-tab" data-bs-toggle="collapse" data-bs-target="#token" type="button" role="tab" aria-controls="pills-profile" aria-selected="false" tabIndex="-1">Buy Token</button>
                                                    {/* <button class="nav-link active" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false" tabindex="-1">Buy Token</button> */}
                                                </li>
                                            </ul>
                                            <div className="tab-content" id="pills-tabContent">
                                                <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab" tabIndex="0">

                                                    { showWith && (<Withdrawal />) }

                                                    { showDepo && (<Deposit />)}

                                                    { showToken && (<Token />)}
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        {/* <!-- service section end --> */}

                    {/* <!-- contact us start --> */}
                    <section className="info-section section-b-space">
                        <div className="container">
                            <div className="info-box" data-aos="fade-in" data-aos-duration="1000" data-aos-delay="100">
                                <div className="hand-effect d-md-block d-none">
                                    {/* <img src="https://themes.pixelstrap.net/mega_bot/assets/svg/hand.svg" className="img-fluid left-hand" alt="hand"/>
                                    <img src="https://themes.pixelstrap.net/mega_bot/assets/svg/hand.svg" className="img-fluid right-hand" alt="hand"/> */}
                                </div>
                                <h2>Token Contract

                                </h2>
                                
                                <ul>
                                    
                                        {/* <img src="https://themes.pixelstrap.net/mega_bot/assets/svg/tick.svg" className="img-fluid" alt="tick"/>Address <br/>

                                    0x78E4464A96Db4BcC65259E705460A624A23d34E8
                                     */}
                                     <li>
                                        <QRCode size={256} className="img-fluid qr-code" style={{ height: "100px", width: "100px" }} value={Address && Address} />
                                        {/* <img src={require("../../assets/svg/home/copy.svg").default} className="img-fluid" alt="tick"/> */}
                                        Address <br/>
                                        {/* 0x78E4464A96Db4BcC65259E705460A624A23d34E8 */}
                                        {Address && Address}
                                        {/* <img src={require("../../assets/svg/home/copy.svg").default} className="img-fluid" alt="tick"/> */}
                                        {/* <svg width="16" height="16" viewBox="0 0 16 16" onClick={handleCopy} fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M6 1.75H12.75H14.25V3.25V10H12.75V3.25H6V1.75ZM9.75 6.25H3.25V12.75H9.75V6.25ZM1.75 4.75V14.25H11.25V4.75H1.75Z" fill="#878787"></path>
                                        </svg>
                                        {copyStatus && <p><i className="fa-solid fa-square-check"></i></p>} */}
                                         {copyStatus === false ?  <svg width="16" height="16" viewBox="0 0 16 16" className='copy-img' onClick={handleCopy} fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M6 1.75H12.75H14.25V3.25V10H12.75V3.25H6V1.75ZM9.75 6.25H3.25V12.75H9.75V6.25ZM1.75 4.75V14.25H11.25V4.75H1.75Z" fill="#ffffff"></path>
                                        </svg> :  <p><i className="fa-solid fa-square-check"></i></p>}
                                    </li>
                                    
                                    <li><img src="https://themes.pixelstrap.net/mega_bot/assets/svg/tick.svg" className="img-fluid" alt="tick"/>Decimal <br/>

                                        18</li>
                                    <li><img src="https://themes.pixelstrap.net/mega_bot/assets/svg/tick.svg" className="img-fluid" alt="tick"/>Network <br/>

                                        Binance Chain
                                        (BEB20)</li>
                                    <li><img src="https://themes.pixelstrap.net/mega_bot/assets/svg/tick.svg" className="img-fluid" alt="tick"/>Token Symbol <br/>

                                        {site?.site?.siteName}</li>
                                </ul>
                                <Link data-cursor="pointer" className="btn-arrow" to={"/buy/token"} >
                                    <div className="icon-arrow"><i className="iconsax" data-icon="arrow-up"></i></div>Buy Now
                                </Link>
                            </div>
                        </div>
                    </section>
                    {/* <!-- contact us end --> */}
                    <Footer/>
                    </div>
                </>
            )
        }
    
    </>
  )
}
